import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllWalletValidity } from "../../../redux/wallet/action";

// Duration type mapping
const durationTypeLabels = {
  1: "Unlimited",
  2: "Days",
  3: "Weeks",
  4: "Months",
  5: "Years",
};

const WalletValiditiesList = () => {
  const list = useSelector((state) => state.reusableSlice.WalletValidityList);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [params] = useState({ page: 1 });

  useEffect(() => {
    dispatch(getAllWalletValidity(params));
  }, [dispatch, params]);

  const updateComponent = (id) => {
    navigate(`/wallet/validities/update/${id}`);
  };

  console.log(list, "list");

  return (
    <div className="card-head order-card">
      <div className="">
        <h2>Wallet Validity List</h2>
      </div>
      <div className="table-sec table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Created On</th>
              <th>Duration</th>
              <th>Duration Type</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {list && list.length > 0 ? (
              list.map((item) => (
                <tr key={item.id}>
                  <td>{item.created_on}</td>
                  <td>{item.duration}</td>
                  <td>{durationTypeLabels[item.duration_type] || "N/A"}</td>
                  <td
                        style={{
                          color:
                            item.status === 1
                              ? "#12b812"
                              : item.status === 2
                              ? "red"
                              : "inherit",
                        }}
                      >
                        <div
                          className=""
                          style={{
                            backgroundColor:
                              item.status === 1
                                ? "#16d11630"
                                : item.status === 2
                                ? "#ff000026"
                                : "inherit",
                            padding: "3px 25px",
                            borderRadius: "50px",
                            textAlign: "center",
                            width: "fit-content",
                          }}
                        >
                          {item.status === 1
                            ? "Active"
                            : item.status === 2
                            ? "Inactive"
                            : ""}
                        </div>
                      </td>
                  <td>
                    <div class="dropdown d-flex justify-content-center">
                      <button
                        class="dropdown-action-btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Action
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a
                          class="dropdown-item"
                          onClick={() => updateComponent(item.id)}
                        >
                          Edit
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WalletValiditiesList;
